class MarqueeAnimation {
  constructor() {
    this.init();
  }

  init() {
    const marqueeSections = document.querySelectorAll('.marquee-section');
    
    marqueeSections.forEach(section => {
      const marqueeContent = section.querySelector('.marquee-content');
      const speed = marqueeContent.dataset.speed || 30;
      
      // Set the animation duration based on speed setting
      const duration = parseInt(speed);
      marqueeContent.style.animationDuration = `${duration}s`;
    });
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new MarqueeAnimation();
});

// Re-initialize on section load (for theme editor)
document.addEventListener('shopify:section:load', () => {
  new MarqueeAnimation();
});
